require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./wharton-india-economic-forum.json") })
        }
      }, "path---wharton-india-economic-forum");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---wharton-india-economic-forum!./.cache/json/wharton-india-economic-forum.json
// module id = 1245
// module chunks = 231608221292675